import { createStore } from 'vuex';
import axios from 'axios';

import * as materials from './modules/materials';
import * as elements from './modules/elements';
import * as barriers from './modules/barriers';
import * as plots from './modules/plots';
import * as faces from './modules/faces';
import * as versions from './modules/versions';
import * as pages from './modules/pages';
import * as orders from './modules/orders';
import * as stells from './modules/stells';
import * as types from './modules/types';
import * as fonts from './modules/fonts';
import * as videoInstructions from './modules/videoInstructions';
import * as notification from './modules/notification';
import * as settings from './modules/settings';
import * as licenses from './modules/licenses';
import * as additionalWorks from './modules/additionalWorks';
import * as adminSearch from './modules/search';

//client
import * as clientMain from './modules/client/main';
import * as clientPlots from './modules/client/plots';
import * as clientPages from './modules/client/pages';
import * as clientVideoInstructions from './modules/client/videoInstructions';
import * as clientBarriers from './modules/client/barriers';

import * as clientElements from './modules/client/elements';
import * as clientOrder from './modules/client/order';
import * as clientEngravings from './modules/client/engravings';
import * as clientLandscaping from './modules/client/landscaping';
import * as clientAdditionalWorks from './modules/client/additionalWorks';
import * as clientComplectation from './modules/client/complectation';
import * as clientEngravingSettings from './modules/client/engravingSettings';
import * as client3dInteractive from './modules/client/3dInteractive';

export default createStore({
    state: () => {
        return {
            license: null,
            renderer: null,
            noShowSceneEnv: 0,
            lowPerformance: 0,
        }
    },
    mutations: {
        FETCH_LICENSE(state, license) {
            state.license = license;
        },
        SET_NO_SHOW_SCENE_ENV(state, noShowEnv) {
            state.noShowSceneEnv = noShowEnv;
        },
        SET_LOW_PERFORMANCE(state, lowPerformance) {
            state.lowPerformance = lowPerformance;
        },
    },
    actions: {
        async fetchLicense({ commit, dispatch }) {

            try {
                const license = (await axios.get('/api/check-license')).data;

                let name;
                switch (license.type) {
                    case 'pro':
                        name = 'Лицензия PRO';
                        break;
                    case 'standard':
                        name = 'Лицензия Стандарт';
                        break;
                    default:
                        name = 'Тестовая 14-ти дневная версия';
                        break;
                }

                commit('FETCH_LICENSE', {
                    name,
                    day_remaining: license.days_remaining,
                    type: license.type,
                    days_used: license.days_used,
                    start_activated_date: license.start_activated_date,
                    finish_activated_date: license.finish_activated_date,
                    activated_at: license.activated_at,
                    key: license.key,
                    active: 1,
                });
            } catch (error) {
                const notification = {
                    type: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true })
            }


        },

        setNoShowSceneEnv({ commit }, noShowEnv) {
            commit('SET_NO_SHOW_SCENE_ENV', noShowEnv);
            localStorage.setItem('noShowSceneEnv', noShowEnv);
        },

        getNoShowSceneEnv({ commit }) {
            const noShowEnv = localStorage.getItem('noShowSceneEnv');
            if (noShowEnv !== null) {
                commit('SET_NO_SHOW_SCENE_ENV', parseInt(noShowEnv));
            }
        },

        setLowPerformance({ commit }, lowPerformance) {
            commit('SET_LOW_PERFORMANCE', lowPerformance);
            localStorage.setItem('lowPerformance', lowPerformance);
        },

        getLowPerformance({ commit }) {
            const lowPerformance = localStorage.getItem('lowPerformance');
            if (lowPerformance !== null) {
                commit('SET_LOW_PERFORMANCE', parseInt(lowPerformance));
            }
        }

    },
    getters: {
        licensed(state) {
            return state.license && state.license.active
        },
    },
    modules: {
        materials,
        elements,
        plots,
        pages,
        orders,
        types,
        fonts,
        faces,
        versions,
        videoInstructions,
        notification,
        stells,
        settings,
        licenses,
        additionalWorks,
        adminSearch,
        barriers,
        clientMain,
        clientPlots,
        clientPages,
        clientVideoInstructions,
        clientElements,
        clientBarriers,
        clientOrder,
        clientEngravings,
        clientLandscaping,
        clientAdditionalWorks,
        clientComplectation,
        ClientEngravingSettings: clientEngravingSettings,
        Client3dInteractive: client3dInteractive
    }
});
